"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  return import(
  /* webpackChunkName: "timeline-components-config-TimelineEventContainer" */
  'crm_ui/timeline/components/config/TimelineEventContainer').then(function (mod) {
    return mod.default;
  });
};

exports.default = _default;
module.exports = exports.default;